export const defaultLocale = 'vi'
export const locales = ['en', 'vi']
